import { Checkbox, Select as KsSelect } from 'kenshin';
import { selectPinyinFilter } from '@/_util/componentsUtil';
import React, { useEffect, useMemo, useState } from 'react';
import { flat } from '@/_util/util';

function getOptionsKey(arr) {
  if (!Array.isArray(arr)) return [];
  return flat(
    arr.map((item) => {
      if (item.options) {
        return item.options.map((item) => item.value);
      }
      return item.value;
    }),
    2,
  );
}

function getDisabledKey(arr) {
  if (!Array.isArray(arr)) return [];
  return flat(
    arr.map((item) => {
      if (item.options) {
        return item.options
          .filter((item) => item.disabled)
          .map((item) => item.value);
      }
      return item.value;
    }),
    2,
  );
}

// checkAlldisabledKey 全选禁用的key，可作为前缀
const Select = ({ checkAlldisabledKey, ...props }) => {
  let [checked, setChecked] = useState(false);
  let [value, setValue] = useState(props.value || []);
  let [searching, setSearching] = useState(false);
  let [searchValue, setSearchValue] = useState('');

  let multiple = props.mode == 'multiple'; // 是否多选

  // 获取搜索过滤后的选项key
  const getFilteredKey = useMemo(() => {
    if (!Array.isArray(props.options)) return [];

    const filterOptions = (options, searchText) => {
      return options.flatMap((option) => {
        if (option.options) {
          const filteredGroup = filterOptions(option.options, searchText);
          return filteredGroup;
        }

        const labelText = React.isValidElement(option.label)
          ? option.label.props.children
          : option.label;

        const matches =
          selectPinyinFilter(labelText, searchText) ||
          labelText?.indexOf(searchText) >= 0;
        return matches ? option.value : [];
      });
    };

    return filterOptions(props.options, searchValue).filter(
      (item) => !item.toString().includes(checkAlldisabledKey),
    );
  }, [props.options, searchValue, checkAlldisabledKey]);

  const disabledKeys = useMemo(() => {
    return getDisabledKey(props.options);
  }, [props.options]);

  useEffect(() => {
    if (multiple) {
      const filteredKeys = getFilteredKey;
      const selectedKeys = Array.from(new Set(props.value || []));
      const intersection = filteredKeys.filter((key) =>
        selectedKeys.includes(key),
      );

      if (
        intersection.length >= filteredKeys.length &&
        filteredKeys.length > 0
      ) {
        setChecked(true);
      } else {
        setChecked(false);
      }
    }
  }, [getFilteredKey, props.value, multiple]);

  useEffect(() => {
    // 多选功能
    if (multiple) {
      setValue(Array.from(new Set(props.value || [])));
    } else {
      setValue(props.value);
    }
  }, [props.value]);

  const checkedAll = (e) => {
    console.log('点击了全选', e.target.checked);

    let value = e.target.checked;
    if (value) {
      props.onChange?.(
        Array.from(new Set([...(props.value || []), ...getFilteredKey])),
      );
      setChecked(true);
    } else {
      // 绕过checkAlldisabledKey 相关
      props.onChange?.([
        ...(props.value || []).filter((item) =>
          item.toString().includes(checkAlldisabledKey),
        ),
        ...disabledKeys,
        ...(props.value || []).filter((item) => {
          const isInFiltered = getFilteredKey.includes(item);
          return !isInFiltered;
        }),
      ]);
      setChecked(false);
    }
  };

  const dropdownRender = (menu) => (
    <>
      {menu}
      {multiple && (
        <div style={{ padding: 10 }} onClick={(e) => e.stopPropagation()}>
          <Checkbox onChange={checkedAll} checked={checked}>
            全选
          </Checkbox>
        </div>
      )}
    </>
  );
  return (
    <KsSelect
      showSearch
      // listHeight={document.body.offsetHeight - 200}
      listHeight={500}
      // allowClear
      onSearch={(value) => {
        setSearchValue(value);
        setSearching(!!value);
      }}
      onFocus={() => {
        if (searchValue) {
          setSearching(true);
        }
      }}
      onBlur={() => {
        setSearching(false);
      }}
      open={searching ? true : undefined}
      searchValue={searchValue}
      filterOption={(input, option) => {
        // 拼音搜索
        const labelText = React.isValidElement(option.label)
          ? option.label.props.children
          : option.label;
        console.log('labelText', labelText);

        return (
          selectPinyinFilter(labelText, input) || labelText?.indexOf(input) >= 0
        );
      }}
      dropdownRender={multiple ? dropdownRender : undefined}
      {...props}
      value={value}
    />
  );
};

export default Select;
